import type { Dayjs } from "dayjs";
import { useEffect, useState } from "react";
import type { DisplayMode, OrderStatus } from "../../data/BaseEntity";
import { endOfNextYear, startOfPreviousMonth } from "../../misc/dateUtils";
import type { GroupType, OrderTag } from "../orderTypes";

export interface OrdersSearchCriteria {
  readonly text: string;
  readonly startDate: Dayjs;
  readonly endDate: Dayjs;
  readonly agentId: string | null;
  readonly customerId: string | null;
  readonly contactPersonEmail: string | null;
  readonly statuses: OrderStatus[];
  readonly tags: OrderTag[];
  readonly groupTypes: GroupType[];
  readonly displayModes: DisplayMode[];
}

export const defaultSearchCriteria: () => OrdersSearchCriteria = () => ({
  text: "",
  startDate: startOfPreviousMonth(),
  endDate: endOfNextYear(),
  agentId: null,
  customerId: null,
  statuses: [],
  tags: [],
  contactPersonEmail: null,
  groupTypes: [],
  displayModes: [],
});

export const useOrderSearch = () => {
  const [ordersSearch, setOrdersSearch] = useState<OrdersSearchCriteria>(defaultSearchCriteria());
  useEffect(() => {
    setOrdersSearch(defaultSearchCriteria());
  }, []);

  return {
    ordersSearch,
    setOrdersSearch: (change: Partial<OrdersSearchCriteria>) => setOrdersSearch((s) => ({ ...s, ...change })),
    clear: () => setOrdersSearch(defaultSearchCriteria()),
  };
};
